/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosButtonProps } from "@components/elements/atoms";
import { ButtonList } from "@components/elements/molecules/button-list";
import { SectionHeading, SectionHeadingProps } from "@components/elements/molecules/section-heading";
import { sectionContentContainer } from "@components/panda-utils";
import { cx } from "@panda/css";
import { Flex, Stack } from "@panda/jsx";

interface RichTextStackProps {
	children: React.ReactNode;
	wide?: boolean | null;
	centered?: boolean | null;
}
export const RichTextStack = ({ children, wide, centered }: RichTextStackProps): React.JSX.Element => {
	return (
		<Stack
			gap="eds.dimension.32"
			className={cx("rich-text-section", sectionContentContainer({ wide: wide || false, centered: centered || false }))}
		>
			{children}
		</Stack>
	);
};

const getRichTextButtons = (buttons: CosmosButtonProps[], component: string): CosmosButtonProps[] => {
	const cosmosButtons = buttons.map((button): CosmosButtonProps => {
		return {
			...button,
			size: "lg",
			analytics: {
				eventCategory: "button",
				interactionType: "click",
				eventAction: "navigation",
				eventLabel: button.name || button.label || "",
				eventValue: {
					component,
				},
			},
		};
	});

	return cosmosButtons;
};

interface RichTextButtonsProps {
	centeredButton?: boolean | null;
	buttons?: CosmosButtonProps[] | null;
	component: string;
}
export const RichTextButtons = ({ buttons, centeredButton, component }: RichTextButtonsProps): React.JSX.Element => {
	const cosmosButtons = getRichTextButtons(buttons || [], component);

	return (
		<Flex width="full" justifyContent={centeredButton ? "center" : "flex-start"}>
			<ButtonList buttons={cosmosButtons} />
		</Flex>
	);
};

export const RichTextHeading = ({
	heading,
	centered,
}: {
	heading?: SectionHeadingProps | null;
	centered?: boolean | null;
}): React.JSX.Element => {
	return (
		<SectionHeading
			{...(heading || {})}
			title={{ ...heading?.title, as: "h2" }}
			centeredVerticalStack={centered || false}
			size="lg"
			mobileTextAlignStart
		/>
	);
};
